import CourseRepository from '../../domain/repositories/CourseRepository';
import CourseDataStoreFactory from '../factories/CourseDataStoreFactory';
import CourseDataStore from '../datastores/CourseDataStore';

export default class CourseDataRepository implements CourseRepository {
  getCourses() {
    const courseDataStore: CourseDataStore = CourseDataStoreFactory.create();
    return courseDataStore.getCourses();
  }

  getCourseSummary(periodId: string) {
    const courseDataStore: CourseDataStore = CourseDataStoreFactory.create();
    return courseDataStore.getCourseSummary(periodId);
  }

  getEnrolledPeriodsByStudent() {
    const courseDataStore: CourseDataStore = CourseDataStoreFactory.create();
    return courseDataStore.getEnrolledPeriodsByStudent();
  }

  getClassAttendance(period: string, sectionId: string) {
    const courseDataStore: CourseDataStore = CourseDataStoreFactory.create();
    return courseDataStore.getClassAttendance(period, sectionId);
  }

  progressiveCertificationEnabled(
    acadPlan: string,
    prog: string,
    carrer: string
  ) {
    const courseDataStore: CourseDataStore = CourseDataStoreFactory.create();
    return courseDataStore.progressiveCertificationEnabled(
      acadPlan,
      prog,
      carrer
    );
  }
}
